import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AccountSelectors } from '@recruitee/account';
import { BillingPlanTier } from '@recruitee/http/types';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { FeatureData, MediaSourceType } from '../feature-guard.model';

@Component({
  selector: 'rt-feature-guard-content',
  templateUrl: './feature-guard-content.component.html',
  styleUrls: ['./feature-guard-content.component.less'],
  host: {
    '[class.no-content-width]': 'featureData.noContentWidth',
  },
})
export class FeatureGuardContentComponent {
  @Input() public featureData: FeatureData;
  @Input() public canUpgrade: boolean;
  @Input() public availableFromPlan: BillingPlanTier | null;

  @Output() public openPlanPicker: EventEmitter<void> = new EventEmitter<void>();

  public helpArticleLang: keyof NonNullable<FeatureData['learnMoreUrlByLang']> = 'en';
  public MediaSourceType: typeof MediaSourceType = MediaSourceType;
  public safeUrl: SafeResourceUrl;

  private ngOnDestroy$ = new Subject<void>();

  constructor(
    public facade: FeatureGuardFacade,
    private store: Store,
    protected cdRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
  ) {}

  public ngOnInit() {
    if (this.featureData.mediaSourceType === MediaSourceType.YoutubeVideo) {
      // eslint-disable-next-line ban/ban
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.featureData.mediaSource);
    }
    if (this.featureData.helpUrl || this.featureData.helpArticleKey) return;
    // TODO after extracting currentCompany
    this.store
      .select(AccountSelectors.currentCompanyWithUser)
      .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(({ currentCompany, currentUser }) => {
        const preferredLanguage = <keyof NonNullable<FeatureData['learnMoreUrlByLang']> | 'auto'>(
          currentUser!.preferredLanguage
        );
        const currentCompanyLanguage = <keyof NonNullable<FeatureData['learnMoreUrlByLang']>>(
          currentCompany!.language
        );
        this.helpArticleLang =
          preferredLanguage === 'auto' ? currentCompanyLanguage || 'en' : preferredLanguage;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
